<template>
  <h1>404</h1>
</template>

<script>

export default {
  name: 'Error404',
  metaInfo() {
    return {
      title: this.$t('pageNotFound'),
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  pageNotFound: Page not found
</i18n>

<i18n locale="ru" lang="yaml">
  pageNotFound: Страница не найдена
</i18n>
